import { openBlock as e, createElementBlock as r, createElementVNode as n, normalizeClass as h, createBlock as x, resolveDynamicComponent as $, toDisplayString as l, renderSlot as d, resolveComponent as _, createVNode as g, Fragment as C, createCommentVNode as p, withCtx as v, renderList as B, createTextVNode as O, withModifiers as L, normalizeStyle as j, mergeModels as H, useModel as P, ref as q, computed as V, unref as k } from "vue";
import { _ as m } from "./_plugin-vue_export-helper-dad06003.js";
import { L as M, a as E, U as A, P as T, S as G, C as F, K as z, H as U, B as N } from "./Building2Icon-f7eef8d4.js";
import { C as W } from "./CardPreloader-af882dfc.js";
import { t as S } from "./CardVideo-a346405d.js";
import { f as un, m as mn, j as fn, a as _n, b as pn, l as hn, c as gn, k as xn, C as yn, e as $n, d as vn } from "./CardVideo-a346405d.js";
import "./FormRichText.model-53e072ea.js";
import "./glightbox-13d8fc52.js";
import { A as I } from "./ChevronLeftIcon-b6affe9b.js";
import { S as K } from "./StoreIcon-ab267c80.js";
import { S as X } from "./ShippingBoxIcon-eeb16070.js";
import { a as J } from "./ButtonTertiaryIconMd-3994fc64.js";
import { C as b } from "./ChevronDownIcon-461d1eb9.js";
import { H as Q } from "./HelpIcon-2069ddad.js";
import { P as R, a as Y } from "./PageDropdownButtonSm-1e68750f.js";
import { C as Z } from "./CardShortcutPrimary-6a7f3f4d.js";
import { a as Cn, b as bn } from "./CardShortcutPrimary-6a7f3f4d.js";
import { B as tt, a as et } from "./ButtonArrows-6c6687fe.js";
import { L as D } from "./DownloadFileIcon-8a003268.js";
import { F as st } from "./FormToggleSm-8b826c8a.js";
import { D as nt } from "./DotsHorizontalIcon-41c0040b.js";
import { C as Sn } from "./CardShortcut-d8584bdc.js";
import { default as Bn } from "./CardGalleryPreview-a1bc6b63.js";
import "./PreloaderIcon-b44be854.js";
import "./ButtonPlay-d3872713.js";
import "./XIcon-e21df3cc.js";
import "./useNotificationHandler.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ButtonCloseSm-209b27c6.js";
import "./_commonjsHelpers-10dfc225.js";
import "./navbars.js";
import "./DropdownDivider-c57dbbbe.js";
import "./CheckIcon-91388c05.js";
import "./DropdownMenu-cf91b06e.js";
const ot = {
  name: "CardWithIcon",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}, rt = { class: "p-4 border ct-border-1 rounded-lg" }, ct = { class: "mt-4 text-sm font-medium ct-text-1" }, at = { class: "mt-2 text-sm ct-text-3" };
function it(s, o, t, u, a, c) {
  return e(), r("div", rt, [
    n("div", {
      class: h(["h-10 w-10 flex items-center justify-center rounded-lg bg-opacity-10", [t.item.app ? `bg-${t.item.app}-500` : ""]])
    }, [
      (e(), x($(t.item.icon), {
        class: h(["h-5 w-5", [t.item.app ? `text-${t.item.app}-500` : ""]])
      }, null, 8, ["class"]))
    ], 2),
    n("p", ct, l(t.item.title), 1),
    n("p", at, l(t.item.subtitle), 1)
  ]);
}
const zs = /* @__PURE__ */ m(ot, [["render", it]]), lt = {
  name: "CardsGrid",
  props: {
    length: {
      type: Number,
      default: 4
    }
  },
  computed: {
    gridClasses() {
      const s = {
        4: "2xl:grid-cols-4",
        3: "2xl:grid-cols-3",
        2: "2xl:grid-cols-2",
        1: "2xl:grid-cols-1"
      }[this.length];
      let o = "grid-cols-2";
      return this.length === 1 && (o = "grid-cols-1"), `${o} ${s}`;
    }
  }
};
function dt(s, o, t, u, a, c) {
  return e(), r("div", {
    class: h(["grid gap-px bg-gray-200 dark:bg-neutral-800", [c.gridClasses]])
  }, [
    d(s.$slots, "default")
  ], 2);
}
const ut = /* @__PURE__ */ m(lt, [["render", dt]]), mt = {
  name: "CardStat",
  components: {
    CardPreloader: W,
    LineChartUpIcon: M,
    LineChartDownIcon: E
  },
  props: {
    stat: {
      type: Object,
      default: () => {
      }
    },
    loading: Boolean
  },
  computed: {
    isIncrease() {
      return this.stat.change > 0;
    },
    isEqual() {
      return this.stat.change === 0;
    },
    absoluteChange() {
      return Math.abs(this.stat.change);
    }
  }
}, ft = { class: "w-full p-5 sm:p-6 ct-bg-1--alt" }, _t = {
  key: 0,
  class: "h-[90px]"
}, pt = { class: "flex items-start text-sm ct-text-3" }, ht = { class: "flex-grow" }, gt = {
  key: 0,
  class: "sm:hidden flex-shrink-0"
}, xt = { class: "w-full flex items-end space-x-1.5" }, yt = { class: "flex-grow mt-3 text-xl sm:text-3xl font-medium ct-text-1" }, $t = {
  key: 0,
  class: "mt-0.5 text-sm ct-text-3"
};
function vt(s, o, t, u, a, c) {
  var w;
  const i = _("CardPreloader"), f = _("LineChartUpIcon"), y = _("LineChartDownIcon");
  return e(), r("div", ft, [
    t.loading ? (e(), r("div", _t, [
      g(i)
    ])) : (e(), r(C, { key: 1 }, [
      n("p", pt, [
        n("span", ht, l(t.stat.name), 1),
        c.isEqual ? p("", !0) : (e(), r("span", gt, [
          c.isIncrease ? (e(), x(f, {
            key: 0,
            class: "ct-text-success h-4 w-4"
          })) : (e(), x(y, {
            key: 1,
            class: "ct-text-error h-4 w-4"
          }))
        ]))
      ]),
      n("div", xt, [
        n("p", yt, l(t.stat.value), 1),
        c.isEqual ? p("", !0) : (e(), r("p", {
          key: 0,
          class: h(["hidden sm:flex flex-shrink-0 space-x-1.5 items-center text-sm font-medium", [c.isIncrease ? "ct-text-success" : "ct-text-error"]])
        }, [
          c.isIncrease ? (e(), x(f, {
            key: 0,
            class: "h-4 w-4"
          })) : (e(), x(y, {
            key: 1,
            class: "h-4 w-4"
          })),
          n("span", null, l(c.absoluteChange) + l(((w = t.stat) == null ? void 0 : w.changeSign) || "%"), 1)
        ], 2))
      ]),
      t.stat.prev_value ? (e(), r("p", $t, "vs. " + l(t.stat.prev_value), 1)) : p("", !0)
    ], 64))
  ]);
}
const wt = /* @__PURE__ */ m(mt, [["render", vt]]), Ct = {
  name: "CardsStats",
  components: {
    CardsGrid: ut,
    CardStat: wt
  },
  props: {
    stats: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    loading() {
      return !this.stats.length;
    },
    items() {
      return this.stats.length ? this.stats : [{}, {}, {}, {}];
    }
  }
};
function bt(s, o, t, u, a, c) {
  const i = _("CardStat"), f = _("CardsGrid");
  return e(), x(f, {
    length: c.items.length
  }, {
    default: v(() => [
      (e(!0), r(C, null, B(c.items, (y, w) => (e(), x(i, {
        key: w,
        stat: y,
        loading: c.loading
      }, null, 8, ["stat", "loading"]))), 128))
    ]),
    _: 1
  }, 8, ["length"]);
}
const Us = /* @__PURE__ */ m(Ct, [["render", bt]]), kt = {
  components: {
    ShippingBoxIcon: X,
    ButtonSecondaryMd: J,
    AddIcon: I,
    StoreIcon: K,
    UsersXIcon: A,
    PieChartIcon: T,
    ShoppingBasketIcon: G,
    CogAutomationIcon: F,
    KeyFrameIcon: z,
    HierarchyIcon: U
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    ctaIcon: {
      type: Object,
      default: I
    },
    ctaLabel: {
      type: String,
      default: ""
    },
    icon: {
      type: Object,
      default: () => ({})
    },
    lightBackground: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["add"]
}, St = { class: "w-14 h-14 rounded-lg ct-bg-4 flex items-center justify-center" }, It = { class: "text-center w-full max-w-sm" }, Bt = { class: "text-lg font-medium ct-text-1" }, Lt = ["innerHTML"];
function jt(s, o, t, u, a, c) {
  const i = _("ButtonSecondaryMd");
  return e(), r("div", {
    class: h(["py-16 px-6 space-y-6 rounded-lg flex flex-col items-center justify-center", [t.lightBackground ? "ct-bg-1" : "ct-bg-2--alt"]])
  }, [
    n("div", St, [
      t.icon ? (e(), x($(t.icon), {
        key: 0,
        class: "h-7 w-7 text-gray-600 dark:text-gray-200"
      })) : p("", !0)
    ]),
    n("div", It, [
      n("p", Bt, l(t.title), 1),
      n("p", {
        class: "mt-2 text-sm ct-text-3",
        innerHTML: t.subtitle
      }, null, 8, Lt)
    ]),
    t.ctaLabel ? (e(), x(i, {
      key: 0,
      onClick: o[0] || (o[0] = (f) => s.$emit("add"))
    }, {
      default: v(() => [
        (e(), x($(t.ctaIcon))),
        n("span", null, l(t.ctaLabel), 1)
      ]),
      _: 1
    })) : p("", !0),
    d(s.$slots, "default")
  ], 2);
}
const Ns = /* @__PURE__ */ m(kt, [["render", jt]]), Dt = {
  components: {
    ChevronDownIcon: b
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isOpen: !0
    };
  }
}, Ot = ["name"], Ht = { class: "flex-grow text-base lg:text-lg ct-text-1 font-medium" }, Pt = {
  key: 0,
  class: "p-6"
};
function qt(s, o, t, u, a, c) {
  const i = _("ChevronDownIcon");
  return e(), r("div", {
    name: t.name,
    "data-scroll": ""
  }, [
    n("div", {
      class: "cursor-pointer h-16 px-5 lg:px-6 flex items-center space-x-2 ct-bg-2--alt border-b ct-border-2 select-none",
      onClick: o[0] || (o[0] = (f) => a.isOpen = !a.isOpen)
    }, [
      n("p", Ht, l(t.title), 1),
      g(i, {
        class: h(["flex-shrink-0 h-4.5 w-4.5 text-gray-700 dark:text-neutral-300 transform transition-transform", {
          "rotate-180": a.isOpen
        }])
      }, null, 8, ["class"])
    ]),
    a.isOpen ? (e(), r("div", Pt, [
      d(s.$slots, "default")
    ])) : p("", !0)
  ], 8, Ot);
}
const Ws = /* @__PURE__ */ m(Dt, [["render", qt]]), Vt = {
  components: {
    ChevronDownIcon: b,
    HelpIcon: Q
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isOpen: !0
    };
  }
}, Mt = { class: "rounded-xl ct-bg-2--alt p-4 select-none" }, Et = { class: "flex-grow text-sm font-medium ct-text-2" }, At = {
  key: 0,
  class: "mt-4 text-sm ct-text-3"
};
function Tt(s, o, t, u, a, c) {
  const i = _("HelpIcon"), f = _("ChevronDownIcon");
  return e(), r("div", Mt, [
    n("div", {
      class: "cursor-pointer flex items-center space-x-2",
      onClick: o[0] || (o[0] = (y) => a.isOpen = !a.isOpen)
    }, [
      g(i, { class: "h-4 w-4 text-sky-600" }),
      n("p", Et, l(t.title), 1),
      g(f, {
        class: h(["flex-shrink-0 h-4.5 w-4.5 text-gray-700 dark:text-neutral-300 transform transition-transform", {
          "rotate-180": a.isOpen
        }])
      }, null, 8, ["class"])
    ]),
    a.isOpen ? (e(), r("div", At, [
      d(s.$slots, "default")
    ])) : p("", !0)
  ]);
}
const Ks = /* @__PURE__ */ m(Vt, [["render", Tt]]), Gt = {
  components: {
    PageDropdownButton: R
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      showDropdown: !1
    };
  }
}, Ft = { class: "cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg p-3 shadow-sm shadow-gray-900/5" }, zt = { class: "flex items-center space-x-2" }, Ut = { class: "flex-grow text-sm overflow-hidden" }, Nt = { class: "font-medium ct-text-1 truncate" }, Wt = { class: "ct-text-3 truncate" }, Kt = {
  key: 0,
  class: "relative flex-shrink-0"
};
function Xt(s, o, t, u, a, c) {
  const i = _("PageDropdownButton");
  return e(), r("div", Ft, [
    n("div", zt, [
      d(s.$slots, "icon"),
      n("div", Ut, [
        n("p", Nt, l(t.item.title), 1),
        n("p", Wt, l(t.item.subtitle), 1)
      ]),
      d(s.$slots, "extra"),
      t.item.actions ? (e(), r("div", Kt, [
        g(i, {
          actions: t.item.actions
        }, null, 8, ["actions"])
      ])) : p("", !0)
    ]),
    d(s.$slots, "default")
  ]);
}
const Xs = /* @__PURE__ */ m(Gt, [["render", Xt]]), Jt = {
  components: {
    PageDropdownButtonSm: Y
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      showDropdown: !1
    };
  }
}, Qt = { class: "flex items-center space-x-2" }, Rt = { class: "flex-grow text-sm overflow-hidden" }, Yt = ["innerHTML"], Zt = { class: "ct-text-3 truncate select-none" }, te = { class: "relative flex-shrink-0" };
function ee(s, o, t, u, a, c) {
  const i = _("PageDropdownButtonSm");
  return e(), r("div", {
    class: h(["cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg p-3 shadow-sm shadow-gray-900/5 space-y-3", {
      "ct-ring-focus": a.showDropdown
    }])
  }, [
    n("div", Qt, [
      d(s.$slots, "icon"),
      n("div", Rt, [
        n("p", {
          class: "font-medium ct-text-1 truncate select-none",
          innerHTML: t.item.title
        }, null, 8, Yt),
        n("p", Zt, l(t.item.subtitle), 1)
      ]),
      d(s.$slots, "extra"),
      n("div", te, [
        g(i, {
          actions: t.item.actions,
          onOpen: o[0] || (o[0] = (f) => a.showDropdown = !0),
          onClose: o[1] || (o[1] = (f) => a.showDropdown = !1)
        }, null, 8, ["actions"])
      ])
    ]),
    d(s.$slots, "inside")
  ], 2);
}
const Js = /* @__PURE__ */ m(Jt, [["render", ee]]), se = {
  components: {
    Building2Icon: N,
    CardIconSm: Z
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  }
}, ne = { class: "cursor-pointer rounded-lg w-[260px]" }, oe = ["src"], re = {
  key: 1,
  class: "border ct-border-1 rounded-t-lg h-[140px]"
}, ce = { class: "border border-t-0 ct-border-1 rounded-b-lg ct-bg-1 p-4" }, ae = { class: "flex items-center space-x-2" }, ie = { class: "text-sm ct-text-2" }, le = { class: "mt-3 text-sm font-medium ct-text-1 h-10 line-clamp-2" }, de = { class: "mt-2 text-base ct-text-2" };
function ue(s, o, t, u, a, c) {
  const i = _("Building2Icon"), f = _("CardIconSm");
  return e(), r("div", ne, [
    t.product.image_url ? (e(), r("img", {
      key: 0,
      class: "border ct-border-1 rounded-t-lg w-full h-[140px] object-cover",
      src: t.product.image_url
    }, null, 8, oe)) : (e(), r("div", re)),
    n("div", ce, [
      n("div", ae, [
        g(f, null, {
          default: v(() => [
            g(i)
          ]),
          _: 1
        }),
        n("p", ie, l(t.product.tenant_name), 1)
      ]),
      n("p", le, l(t.product.name), 1),
      n("p", de, l(t.product.price), 1)
    ])
  ]);
}
const Qs = /* @__PURE__ */ m(se, [["render", ue]]), me = {
  components: {
    ButtonArrows: tt
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    sliderClass: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      slider: null
    };
  },
  mounted() {
    this.startSlider();
  },
  beforeUnmount() {
    this.destroySlider();
  },
  methods: {
    startSlider() {
      typeof S > "u" || !document.querySelector(`.${this.sliderClass}`) || (this.slider = S({
        container: `.${this.sliderClass}`,
        gutter: 16,
        slideBy: "page",
        nav: !1,
        loop: !1,
        nextButton: document.querySelector(`.${this.sliderClass}Btns .slider-arrow-right`),
        prevButton: document.querySelector(`.${this.sliderClass}Btns .slider-arrow-left`),
        ...this.config
      }));
    },
    destroySlider() {
      var s;
      (s = this.slider) == null || s.destroy();
    }
  }
}, fe = { class: "flex flex-col sm:flex-row items-start justify-between space-y-4 sm:space-y-0 sm:space-x-4 mb-6" }, _e = { class: "w-full max-w-sm flex-grow" }, pe = {
  key: 0,
  class: "text-xl font-medium ct-text-1"
};
function he(s, o, t, u, a, c) {
  const i = _("ButtonArrows");
  return e(), r("div", null, [
    n("div", fe, [
      n("div", _e, [
        t.title ? (e(), r("h3", pe, l(t.title), 1)) : p("", !0),
        d(s.$slots, "header")
      ]),
      g(i, {
        class: h(["self-end sm:self-auto flex-shrink-0", `${t.sliderClass}Btns`]),
        colors: t.colors
      }, null, 8, ["class", "colors"])
    ]),
    n("div", {
      class: h(t.sliderClass)
    }, [
      d(s.$slots, "default")
    ], 2)
  ]);
}
const Rs = /* @__PURE__ */ m(me, [["render", he]]), ge = {
  props: {
    title: {
      type: String,
      required: !0
    },
    subtitle: {
      type: String,
      default: ""
    },
    mobile: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasActions() {
      return this.$slots.actions !== void 0;
    }
  }
}, xe = { class: "flex-grow flex flex-col space-y-3" }, ye = { class: "text-sm space-y-1" }, $e = { class: "font-medium ct-text-1" }, ve = { class: "ct-text-3" };
function we(s, o, t, u, a, c) {
  return e(), r("div", {
    class: h(["rounded-xl border ct-border-1 p-4 flex flex-col space-y-4", [t.mobile ? "sm:p-6" : "sm:flex-row sm:items-center sm:space-y-0 sm:space-x-4"]])
  }, [
    n("div", xe, [
      d(s.$slots, "icon"),
      n("div", ye, [
        n("p", $e, l(t.title), 1),
        n("p", ve, [
          O(l(t.subtitle) + " ", 1),
          d(s.$slots, "subtitle")
        ])
      ])
    ]),
    c.hasActions ? (e(), r("div", {
      key: 0,
      class: h(["flex flex-col space-y-2", [t.mobile ? "" : "sm:flex-row sm:space-y-0 sm:space-x-2 "]])
    }, [
      d(s.$slots, "actions")
    ], 2)) : p("", !0)
  ], 2);
}
const Ys = /* @__PURE__ */ m(ge, [["render", we]]), Ce = {}, be = { class: "cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg p-3 flex items-center space-x-2 shadow-sm shadow-gray-900/5" }, ke = { class: "flex-grow text-sm overflow-hidden" };
function Se(s, o) {
  return e(), r("div", be, [
    n("div", ke, [
      d(s.$slots, "default")
    ])
  ]);
}
const Zs = /* @__PURE__ */ m(Ce, [["render", Se]]), Ie = {}, Be = { class: "rounded-lg ct-text-3 ct-bg-3 p-3 text-sm text-ellipsis overflow-hidden" };
function Le(s, o) {
  return e(), r("div", Be, [
    n("code", null, [
      d(s.$slots, "default")
    ])
  ]);
}
const tn = /* @__PURE__ */ m(Ie, [["render", Le]]), je = {
  components: {
    LinkChainIcon: D,
    FormToggleSm: st
  },
  props: {
    modelValue: Boolean,
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(s) {
        this.$emit("update:modelValue", s);
      }
    }
  }
}, De = { class: "cursor-pointer ring-1 ring-inset ct-ring-1 hover:ct-ring-brand ct-bg-1--alt rounded-lg p-3 flex items-center space-x-2 shadow-sm shadow-gray-900/5" }, Oe = { class: "font-medium ct-text-1 truncate" }, He = {
  key: 0,
  class: "ct-text-3 truncate"
};
function Pe(s, o, t, u, a, c) {
  const i = _("LinkChainIcon"), f = _("FormToggleSm");
  return e(), r("div", De, [
    g(i, { clas: "flex-shrink-0 h-5 w-5 ct-fg-3" }),
    n("div", {
      class: "flex-grow text-sm overflow-hidden",
      onClick: o[0] || (o[0] = (y) => c.model = !c.model)
    }, [
      n("p", Oe, l(t.item.title), 1),
      t.item.subtitle ? (e(), r("p", He, l(t.item.subtitle), 1)) : p("", !0)
    ]),
    g(f, {
      modelValue: c.model,
      "onUpdate:modelValue": o[1] || (o[1] = (y) => c.model = y)
    }, null, 8, ["modelValue"])
  ]);
}
const en = /* @__PURE__ */ m(je, [["render", Pe]]), qe = {}, Ve = { class: "ct-card-empty" };
function Me(s, o) {
  return e(), r("div", Ve, [
    d(s.$slots, "default")
  ]);
}
const sn = /* @__PURE__ */ m(qe, [["render", Me]]), Ee = {
  name: "CardHoverLink",
  components: {
    LinkChainIcon: D
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    icon: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    openLink() {
      window.open(this.link, "_blank");
    }
  }
}, Ae = { class: "relative h-10 w-10 rounded-lg overflow-hidden" }, Te = ["src"], Ge = {
  key: 1,
  class: "h-full w-full ct-bg-brand--2 flex items-center justify-center"
}, Fe = ["href"];
function ze(s, o, t, u, a, c) {
  const i = _("LinkChainIcon");
  return e(), r("div", Ae, [
    t.src ? (e(), r("img", {
      key: 0,
      src: t.src,
      class: "w-full h-full object-cover"
    }, null, 8, Te)) : (e(), r("div", Ge, [
      t.icon ? (e(), x($(t.icon), {
        key: 0,
        class: "w-5 h-5 text-gray-600 dark:text-neutral-200"
      })) : p("", !0)
    ])),
    t.link ? (e(), r("a", {
      key: 2,
      href: t.link,
      target: "_blank",
      class: "absolute inset-0 ct-bg-overlay opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center",
      onClick: o[0] || (o[0] = L((...f) => c.openLink && c.openLink(...f), ["stop"]))
    }, [
      g(i, { class: "w-5 h-5 text-white" })
    ], 8, Fe)) : p("", !0)
  ]);
}
const nn = /* @__PURE__ */ m(Ee, [["render", ze]]), Ue = {
  components: {
    DotsHorizontalIcon: nt
  },
  props: {
    heightLimit: {
      type: Number,
      default: 120
    }
  },
  data() {
    return {
      fadeEffect: !1
    };
  },
  mounted() {
    this.$refs.code && this.$refs.code.clientHeight >= this.heightLimit && (this.fadeEffect = !0);
  }
}, Ne = {
  key: 0,
  class: "absolute left-0 bottom-4 w-full h-12 bg-gradient-to-t from-white dark:from-neutral-900 via-white dark:via-neutral-900 opacity-90"
}, We = {
  key: 1,
  class: "absolute left-0 bottom-0 w-full h-6 bg-white dark:bg-neutral-900"
}, Ke = {
  key: 2,
  class: "absolute bottom-1 left-1/2 transform -translate-x-1/2 ct-text-1 opacity-20"
};
function Xe(s, o, t, u, a, c) {
  const i = _("DotsHorizontalIcon");
  return e(), r("div", {
    ref: "code",
    class: "relative rounded-lg ct-bg-3 p-3 text-sm text-ellipsis overflow-hidden",
    style: j({ "max-height": `${t.heightLimit}px` })
  }, [
    n("code", null, [
      d(s.$slots, "default")
    ]),
    a.fadeEffect ? (e(), r("div", Ne)) : p("", !0),
    a.fadeEffect ? (e(), r("div", We)) : p("", !0),
    a.fadeEffect ? (e(), r("span", Ke, [
      g(i, { class: "h-4 w-4" })
    ])) : p("", !0)
  ], 4);
}
const on = /* @__PURE__ */ m(Ue, [["render", Xe]]), Je = {
  name: "CardSquare",
  props: {
    isSelected: Boolean,
    title: {
      type: String,
      default: ""
    }
  }
}, Qe = { class: "cursor-pointer group space-y-2" }, Re = { class: "text-xs ct-text-2 font-medium text-center" };
function Ye(s, o, t, u, a, c) {
  return e(), r("div", Qe, [
    n("div", {
      class: h(["h-22 w-22 ct-bg-1 rounded-lg overflow-hidden flex items-center justify-center shadow-sm shadow-gray-900/5 ct-fg-4", [
        t.isSelected ? "ring-2 ct-ring-focus" : "ring-1 ct-ring-1 group-hover:ct-ring-brand"
      ]])
    }, [
      d(s.$slots, "default")
    ], 2),
    n("p", Re, l(t.title), 1)
  ]);
}
const Ze = /* @__PURE__ */ m(Je, [["render", Ye]]), ts = {
  name: "CardSquareColors",
  components: {
    CardSquare: Ze
  },
  props: {
    isSelected: Boolean,
    title: {
      type: String,
      default: ""
    },
    colors: {
      type: Array,
      default: () => []
    }
  }
}, es = { class: "w-full h-full grid grid-cols-2 gap-1 p-1.5" };
function ss(s, o, t, u, a, c) {
  const i = _("CardSquare");
  return e(), x(i, {
    "is-selected": t.isSelected,
    title: t.title
  }, {
    default: v(() => [
      n("div", es, [
        (e(!0), r(C, null, B(t.colors, (f, y) => (e(), r("div", {
          key: `color-${y}`,
          class: h(["rounded border ct-border-3", [f ? "opacity-100" : "opacity-0"]]),
          style: j({ "background-color": f })
        }, null, 6))), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-selected", "title"]);
}
const rn = /* @__PURE__ */ m(ts, [["render", ss]]), ns = {}, os = { class: "grid grid-cols-[repeat(auto-fit,88px)] gap-3" };
function rs(s, o) {
  return e(), r("div", os, [
    d(s.$slots, "default")
  ]);
}
const cn = /* @__PURE__ */ m(ns, [["render", rs]]), cs = { class: "w-full ring-1 ring-inset ct-ring-1 ct-bg-1--alt rounded-lg flex flex-col space-x-2 shadow-sm" }, as = { class: "flex items-center space-x-3" }, is = { class: "w-6 h-6 rounded-lg flex items-center justify-center ct-bg-brand--2" }, ls = { class: "flex-grow text-sm overflow-hidden" }, ds = { class: "font-medium ct-text-1 truncate" }, us = { class: "flex items-center" }, ms = {
  key: 0,
  class: "p-3"
}, an = {
  __name: "CardToggleAlt",
  props: /* @__PURE__ */ H({
    icon: {
      type: Object,
      default: () => {
      }
    },
    title: {
      type: String,
      required: !0
    }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(s) {
    const o = P(s, "modelValue"), t = q(!1), u = V({
      get: () => o.value ?? t.value,
      set: (a) => {
        o.value !== void 0 ? o.value = a : t.value = a;
      }
    });
    return (a, c) => (e(), r("div", cs, [
      n("div", {
        class: "flex w-full items-center justify-between p-3 max-h-12 cursor-pointer",
        onClick: c[1] || (c[1] = (i) => u.value = !u.value)
      }, [
        n("div", as, [
          n("div", is, [
            (e(), x($(s.icon), { class: "w-3 h-3 ct-text-4 dark:text-neutral-200" }))
          ]),
          n("div", ls, [
            n("p", ds, l(s.title), 1)
          ])
        ]),
        n("div", us, [
          n("div", {
            onClick: c[0] || (c[0] = L(() => {
            }, ["stop"]))
          }, [
            d(a.$slots, "actions")
          ]),
          g(k(et), null, {
            default: v(() => [
              g(k(b), {
                class: h({ "rotate-180": u.value })
              }, null, 8, ["class"])
            ]),
            _: 1
          })
        ])
      ]),
      u.value ? (e(), r("div", ms, [
        d(a.$slots, "default")
      ])) : p("", !0)
    ]));
  }
};
export {
  tn as CardCode,
  on as CardCodeHeight,
  Xs as CardDropdown,
  Js as CardDropdownSm,
  Ns as CardEmpty,
  sn as CardEmptySm,
  un as CardFile,
  mn as CardFileHorizontal,
  fn as CardGalleryEditItem,
  _n as CardGalleryItem,
  pn as CardGalleryItemMd,
  Bn as CardGalleryPreview,
  Ys as CardHorizontal,
  Zs as CardHover,
  nn as CardHoverLink,
  Cn as CardIcon,
  Z as CardIconSm,
  Ks as CardInfo,
  en as CardLink,
  W as CardPreloader,
  Qs as CardProduct,
  Sn as CardShortcut,
  bn as CardShortcutPrimary,
  Ze as CardSquare,
  rn as CardSquareColors,
  wt as CardStat,
  Ws as CardToggle,
  an as CardToggleAlt,
  hn as CardVideo,
  zs as CardWithIcon,
  gn as CardsGallery,
  ut as CardsGrid,
  xn as CardsGridGallery,
  yn as CardsInlineSlider,
  $n as CardsInlineSliderMdWithPreview,
  vn as CardsInlineSliderWithPreview,
  Rs as CardsSlider,
  cn as CardsSquare,
  Us as CardsStats
};
